module.exports = __webpack_public_path__ + "img/nodata.c709e214.png";